import { Box, Typography } from '@mui/material';
import ContainerBox from 'components/ContainerBox';
import React from 'react';
import { useTranslation } from 'services/localization';
import ManualPaymentMethods from './components/ManualPaymentMethods';
import { useHasFeature } from 'hooks/useHasFeature';

const Manual = () => {
	const { t } = useTranslation();
	const { hasFeature } = useHasFeature();
	const hasManualPaymentMethods = hasFeature('MANUAL_PAYMENT_METHODS');
	return (
		<ContainerBox style={{ overflow: 'auto' }}>
			<Box>
				<Typography variant="h5">
					{t('account.payments.manualPayments', 'Manual payment methods')}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{hasManualPaymentMethods
						? t(
								'account.payments.manualPaymentsDescription',
								'Accept pay in-store, pay by voucher or other custom payment methods through your sales channels',
						  )
						: t(
								'account.payments.notExtendedManualPaymentsDescription',
								'Enable pay in-store to accept orders without pre-payment. Add custom payment methods such as vouchers, invoices, and others by enabling Custom Manual Payment Methods.',
						  )}
				</Typography>
			</Box>
			<ManualPaymentMethods />
		</ContainerBox>
	);
};

export default Manual;
